import React from "react";
import { map } from "lodash";
import { CartItem } from "../types/Cart";
import {
  calculateItemCountInCart,
  calculateItemTotal,
  calculateCartTotal,
} from "../lib/cart";
import "./Cart.css";

interface CartProps {
  items: CartItem[];
  onDecrement?: (productId: number) => void;
  onIncrement?: (item: CartItem) => void;
}

export const Cart: React.FC<CartProps> = ({
  items,
  onDecrement,
  onIncrement,
}) => {
  if (items.length === 0) {
    return (
      <div className="cart">
        <h2>Your Cart</h2>
        <div className="cart-empty">
          <p>Your cart is empty</p>
          <p className="cart-empty-hint">Add some products to get started!</p>
        </div>
      </div>
    );
  }

  return (
    <div className="cart">
      <h2>Your Cart ({calculateItemCountInCart(items)})</h2>
      <div className="cart-items">
        {map(items, (item) => (
          <div key={item.id} className="cart-item">
            <img
              src={item.image}
              alt={item.title}
              className="cart-item-image"
            />
            <div className="cart-item-details">
              <h4 className="cart-item-title">{item.title}</h4>
              <p className="cart-item-price">R {item.price.toFixed(2)}</p>
              <div className="cart-item-quantity">
                {onDecrement && (
                  <button
                    className="cart-item-qty-btn"
                    onClick={() => onDecrement(item.id)}
                    aria-label={`Decrease quantity of ${item.title}`}
                  >
                    -
                  </button>
                )}
                <span>Qty: {item.quantity}</span>
                {onIncrement && (
                  <button
                    className="cart-item-qty-btn"
                    onClick={() => onIncrement(item)}
                    aria-label={`Increase quantity of ${item.title}`}
                  >
                    +
                  </button>
                )}
              </div>
            </div>
            <div className="cart-item-total">
              R {calculateItemTotal(item).toFixed(2)}
            </div>
          </div>
        ))}
      </div>
      <div className="cart-summary">
        <div className="cart-total">
          <span>Total:</span>
          <span className="cart-total-amount">
            R {calculateCartTotal(items).toFixed(2)}
          </span>
        </div>
      </div>
    </div>
  );
};
